var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D80027;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#F0F0F0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256C87.9,168.1,162.5,93.5,256,0C397.4,0,512,114.6,512,256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,256c0-141.4,0-158.1,0-256C114.6,0,0,114.6,0,256H256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.1,167l4.1,12.8h13.4l-10.9,7.9l4.1,12.8l-10.9-7.9l-10.9,7.9l4.1-12.8l-10.9-7.9h13.4L205.1,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.7,66.8l6.9,21.3H167l-18.1,13.1l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3L108.4,88h22.3L137.7,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M204.5,89l6.9,21.3h22.4l-18.1,13.1l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.4L204.5,89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.7,178.1l6.9,21.3H181l-18.1,13.1l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.4L151.7,178.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93.2,122.4l6.9,21.3h22.4l-18.1,13.1l6.9,21.3l-18.1-13.1l-18.1,13.1l6.9-21.3l-18.1-13.1h22.3L93.2,122.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWs);
export default __webpack_public_path__ + "static/media/ws.4ce453564b39f519e9f4000d3a78a1d7.svg";
export { ForwardRef as ReactComponent };